export default __webpack_public_path__ + "static/blob1-058c151a295ca9c4a0db45309f1df07b.svg";